import * as MapRepository from "repository/MapRepository";
import TableFactory from "util/TableFactory";

export const getMaps = async (mapIds) => {
    const promises = mapIds.map(mapId => getMap(mapId));
    let loadedMaps = await Promise.all(promises);

    return loadedMaps.reduce((accumulator, current) => {
        //index each map by its id
        const {id, ...map} = current
        accumulator[id] = map;
        return accumulator
    }, {})
}

export const getMap = async (mapId) => {
    //type and metadata present in both but chose to take it from modified
    let {uploaded, original, ...mapMetadata} = await MapRepository.getMap(mapId);
    let {modified, type, ...mapModifiedMetadata} = await MapRepository.getMapModified(mapId);

    uploaded = TableFactory.createTable({...uploaded, type});
    original = TableFactory.createTable({...original, type});
    modified = TableFactory.createTable({...modified, type});

    return { ...mapMetadata, ...mapModifiedMetadata, uploaded, original, modified };
}

export const getMapModified = async (mapId) => {
    const {modified, type} = await MapRepository.getMapModified(mapId);
    return TableFactory.createTable({...modified, type});
}

export const setMapModified = async (mapId, table) => {
    await MapRepository.setMapModified(mapId, table);
    return await MapRepository.isMapModified(mapId); //check that actually modified (may not be in case of undo)
}

export const setMapModifiedAxis = async (mapId, axisId, modifiedAxisData) => {
    //assume that the modified state of the targeted axis is the same for whole list of affected axes to save checking each
    const modifiedMaps = await MapRepository.setMapModifiedAxis(mapId, axisId, modifiedAxisData);
    const isModified = await MapRepository.isMapModified(mapId); //check that actually modified (may not be in case of undo)
    return [modifiedMaps, isModified];
}

export const toggleMapFavourited = async (mapId) => {
    return MapRepository.toggleMapFavourited(mapId)
}

export const undoMapByOneVersion = async (mapId) => {
    const versions = await MapRepository.getMapUndoVersions(mapId);
    if (!versions[0]) return await MapRepository.isMapModified(mapId);

    await MapRepository.applyMapUndo(mapId, versions[0]);

    return await MapRepository.isMapModified(mapId);
}